import React from 'react';
import './ToolCollisionConfirmModal.css';

function ToolCollisionConfirmModal({
  isOpen,
  collisions = [],
  pairs = [],
  onSave,
  onFix,
  saving = false,
}) {
  if (!isOpen) return null;

  const pairLabels = (pairs || []).map(
    (p) => `“${p.groupA}” and “${p.groupB}”`
  );
  const pairText = pairLabels.length
    ? pairLabels.join('; ')
    : 'selected groups';

  return (
    <div className="tool-collision-overlay">
      <div
        className="tool-collision-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="tool-collision-title"
      >
        <h3 id="tool-collision-title">Field collisions across ingestion groups</h3>
        <p>
          Some fields are not available in every selected group. The tool works best when
          search and return fields exist in all groups.
        </p>
        <p className="tool-collision-question">
          Do you wish to save, or address the collision issues between {pairText}?
        </p>
        <ul className="tool-collision-list">
          {(collisions || []).map((c) => (
            <li key={`${c.role}-${c.key}`}>
              <strong>{c.key}</strong> ({c.role}) — missing in: {(c.missingInGroups || []).join(', ')}
            </li>
          ))}
          {(pairs || []).map((p) => (
            <li key={`${p.groupA}-${p.groupB}`}>
              <strong>{p.groupA}</strong> vs <strong>{p.groupB}</strong>: {(p.fields || []).join(', ')}
            </li>
          ))}
        </ul>
        <div className="tool-collision-actions">
          <button type="button" className="btn btn-secondary" onClick={onFix} disabled={saving}>
            Fix
          </button>
          <button type="button" className="btn btn-primary" onClick={onSave} disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ToolCollisionConfirmModal;
